import { useCallback } from 'react';

import {
  userConnectedAppDataManagementTabViewedEvent,
  userConnectedAppEgressDeleteModalViewedEvent,
  userConnectedAppEgressModalViewedEvent,
  userConnectedAppResetRemoteModalViewedEvent,
  userConnectedAppUpdateRemoteModalViewedEvent,
} from './analytics-event-data/analytics-event-data';
import { useAnalyticsClient } from './use-analytics-client';

export function useDataManagementAnalytics() {
  const { sendUIEvent } = useAnalyticsClient();

  const viewedDataManagementTab = useCallback(() => {
    sendUIEvent(userConnectedAppDataManagementTabViewedEvent());
  }, [sendUIEvent]);

  const viewedEgressModal = useCallback(() => {
    sendUIEvent(userConnectedAppEgressModalViewedEvent());
  }, [sendUIEvent]);

  const viewedUpdateRemoteModal = useCallback(() => {
    sendUIEvent(userConnectedAppUpdateRemoteModalViewedEvent());
  }, [sendUIEvent]);

  const viewedResetRemoteModal = useCallback(() => {
    sendUIEvent(userConnectedAppResetRemoteModalViewedEvent());
  }, [sendUIEvent]);

  const viewedEgressDeleteModal = useCallback(() => {
    sendUIEvent(userConnectedAppEgressDeleteModalViewedEvent());
  }, [sendUIEvent]);

  return {
    viewedDataManagementTab,
    viewedEgressModal,
    viewedUpdateRemoteModal,
    viewedResetRemoteModal,
    viewedEgressDeleteModal,
  };
}
